// services/homeService.js
// import { useData, useMutation, API_METHODS } from '@/lib/services/helperService';
import { ConstantService } from 'src/constants/apiPaths';
import { API_METHODS, useData, useMutation } from '.';

// API Routes constants


// Custom hooks for each endpoint
export function useHomeList(data) {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.homeNew);
  
  // Function to fetch home list
  const fetchHomeList = async (postData = data) => {
    try {
      return await updateData(postData, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    fetchHomeList,
    loading
  };
}

export function useGeoCodeAddress(city) {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${city}&key=${process.env.NEXT_PUBLIC_GOOGLE_API_KEY}`

  const { data, error, isLoading } = useData(url);

  return {
    geoData: data,
    error,
    isLoading
  };
}




export function useFleetList(data) {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.fleetNew);
  const fetchFleetList = async (postData = data) => {
    try {
      return await updateData(postData, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };

  return {
    fetchFleetList,
    loading
  };
}


export function useIpLocation() {
  const { data, error, isLoading } = useData(ConstantService.apiRoutes.ipLocation);
  const ipData = data?.data.ipCountry || 'AE'; // Fallback to 'AE' if no data is returned

  return {
    ipData,
    error,
    isLoading
  };
}


export async function fetchFleetListServer(postData = data) {
  const { updateData, loading } = useMutation(ConstantService.apiRoutes.fleetNew);
  try {
    return await updateData(postData, API_METHODS.POST);
  } catch (error) {
    throw error;
  }
};

  
  // Function to fetch home list
  export async function fetchHomeListServer(postData = data)  {
    const { updateData, loading } = useMutation(ConstantService.apiRoutes.homeNew);
    try {
      return await updateData(postData, API_METHODS.POST);
    } catch (error) {
      throw error;
    }
  };